import React from "react";

const fontClass = (f) => f || "font-plex-r";

export default function ResumePreview({ data, style }) {
  const accent = style?.accent || "#0047AB";
  const size = style?.fontSize || 10;
  const p = data?.personal || {};
  const spacing = style?.spacing === "airy" ? "space-y-6" : style?.spacing === "compact" ? "space-y-3" : "space-y-5";

  return (
    <div
      className={`a4-page ${fontClass(style?.fontFamily)}`}
      style={{ fontSize: `${size}pt`, color: "#0A0A0A" }}
      id="resume-canvas"
    >
      <div className="p-[16mm]">
        {/* HEADER */}
        <div className="flex items-start justify-between gap-6 border-b-2 pb-4" style={{ borderColor: "#0A0A0A" }}>
          <div>
            <div className="uppercase font-black leading-none" style={{ fontSize: `${size * 2.4}pt`, letterSpacing: "-0.02em" }}>{p.name || "Your Name"}</div>
            <div className="mt-1" style={{ color: accent, fontSize: `${size * 1.2}pt` }}>{p.title || "Your Title"}</div>
            <div className="mt-2 text-neutral-700 flex flex-wrap gap-x-3 gap-y-0.5" style={{ fontSize: `${size * 0.9}pt` }}>
              {p.email && <span>{p.email}</span>}
              {p.phone && <span>· {p.phone}</span>}
              {p.location && <span>· {p.location}</span>}
              {p.website && <span>· {p.website}</span>}
            </div>
          </div>
          {data?.photo && (
            <img src={data.photo} alt="portrait" className="w-24 h-24 object-cover" style={{ border: "1px solid #0A0A0A" }} />
          )}
        </div>

        <div className={`mt-6 ${spacing}`}>
          {/* SUMMARY */}
          {data?.summary && (
            <section>
              <div className="label-eyebrow" style={{ color: accent }}>Summary</div>
              <p className="mt-2 leading-relaxed text-neutral-800" style={{ fontSize: `${size}pt` }}>{data.summary}</p>
            </section>
          )}

          {/* EXPERIENCE */}
          {data?.experience?.length > 0 && (
            <section>
              <div className="label-eyebrow" style={{ color: accent }}>Experience</div>
              <div className="mt-2 space-y-4">
                {data.experience.map((e, i) => (
                  <div key={i}>
                    <div className="flex justify-between items-baseline">
                      <div className="font-bold">{e.role || "Role"} <span className="font-normal text-neutral-600">· {e.company || "Company"}</span></div>
                      <div className="text-neutral-600" style={{ fontSize: `${size * 0.85}pt` }}>{e.period || ""}</div>
                    </div>
                    {e.bullets && (
                      <ul className="mt-1 list-disc ml-4 space-y-0.5 text-neutral-800">
                        {String(e.bullets).split("\n").filter(Boolean).map((b, j) => (
                          <li key={j}>{b.replace(/^[-•]\s?/, "")}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* EDUCATION */}
          {data?.education?.length > 0 && (
            <section>
              <div className="label-eyebrow" style={{ color: accent }}>Education</div>
              <div className="mt-2 space-y-2">
                {data.education.map((e, i) => (
                  <div key={i} className="flex justify-between items-baseline">
                    <div><span className="font-bold">{e.school}</span> — {e.degree}</div>
                    <div className="text-neutral-600" style={{ fontSize: `${size * 0.85}pt` }}>{e.period}</div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* SKILLS */}
          {data?.skills?.length > 0 && (
            <section>
              <div className="label-eyebrow" style={{ color: accent }}>Skills</div>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {data.skills.map((s, i) => (
                  <span key={i} className="px-2 py-0.5" style={{ border: "1px solid #0A0A0A", fontSize: `${size * 0.9}pt` }}>{s}</span>
                ))}
              </div>
            </section>
          )}

          {/* CERTIFICATES */}
          {data?.certificates?.length > 0 && (
            <section>
              <div className="label-eyebrow" style={{ color: accent }}>Certificates</div>
              <div className="mt-2 grid grid-cols-2 gap-3">
                {data.certificates.map((c, i) => (
                  <div key={i} className="flex gap-3 items-start" style={{ border: "1px solid #0A0A0A", padding: "8px" }}>
                    {c.image && <img src={c.image} alt="cert" className="w-14 h-14 object-cover" style={{ border: "1px solid #0A0A0A" }} />}
                    <div>
                      <div className="font-bold" style={{ fontSize: `${size}pt` }}>{c.name}</div>
                      <div className="text-neutral-600" style={{ fontSize: `${size * 0.85}pt` }}>{c.issuer} · {c.year}</div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
